import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " 列の項目名とアップロードした内容が一致しているかご確認ください。 ", -1)
const _hoisted_2 = { class: "submit" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("登録する")


  import { QuestionRecord } from '@/logic/questionImport/ExcelUploadLogic'

  interface Props {
    data: QuestionRecord[];
  }
  interface Emits {
    (e: "onSubmit"): void
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    data: { type: Array, required: true }
  },
  emits: ["onSubmit"],
  setup(__props: any, { emit }: { emit: ({
    (e: "onSubmit"): void
  }), expose: any, slots: any, attrs: any }) {

  

  

  const handleSubmit = () => {
    emit('onSubmit');
  };

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_table, {
      data: __props.data,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "body",
          label: "質問"
        }),
        _createVNode(_component_el_table_column, {
          prop: "answer",
          label: "解答"
        }),
        _createVNode(_component_el_table_column, {
          prop: "question_category_id",
          label: "カテゴリ",
          width: "180"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, { onClick: handleSubmit }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})